import React from 'react';

const ConversationSidebar = ({
  conversations,
  currentConversationId,
  onSelectConversation,
  onNewConversation,
  onDeleteConversation,
  isOpen,
  onClose,
}) => {
  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          data-testid="sidebar-overlay"
          className="fixed inset-0 bg-espresso bg-opacity-20 z-20 md:hidden"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <div
        data-testid="conversation-sidebar"
        className={`
          fixed md:relative z-30
          w-80 h-full
          bg-warm-sand border-r-2 border-border
          transform transition-transform duration-300
          ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
      >
        <div className="flex flex-col h-full p-6 custom-scroll overflow-y-auto">
          {/* Header */}
          <div className="mb-8">
            <button
              data-testid="new-conversation-btn"
              onClick={onNewConversation}
              className="w-full btn-primary"
            >
              <div className="flex items-center justify-center space-x-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                <span>New Conversation</span>
              </div>
            </button>
          </div>
          
          {/* Conversations list */}
          <div className="flex-1 space-y-3">
            {conversations.length === 0 ? (
              <p className="empty-state text-sm">No conversations yet</p>
            ) : (
              conversations.map((conv) => (
                <div
                  key={conv.id}
                  data-testid={`conversation-item-${conv.id}`}
                  className={`
                    group relative card cursor-pointer transition-all
                    ${currentConversationId === conv.id
                      ? 'shadow-hover bg-white border-honey'
                      : 'hover:shadow-hover'
                    }
                  `}
                  onClick={() => {
                    onSelectConversation(conv.id);
                    onClose();
                  }}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <p className="color-espresso font-medium truncate mb-1">
                        {conv.title}
                      </p>
                      <p className="text-sm color-warm-gray">
                        {new Date(conv.updated_at).toLocaleDateString([], {
                          month: 'short',
                          day: 'numeric'
                        })}
                      </p>
                    </div>
                    
                    <button
                      data-testid={`delete-conversation-${conv.id}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteConversation(conv.id);
                      }}
                      className="opacity-0 group-hover:opacity-100 ml-2 p-2 hover:bg-parchment rounded-xl transition-all"
                    >
                      <svg className="w-4 h-4 color-clay" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
          
          {/* Footer */}
          <div className="mt-6 pt-6 border-t border-border">
            <p className="text-xs color-warm-gray text-center font-light italic">
              breathing with presence
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConversationSidebar;